import React from 'react';
import { BillingSummary, BillingItem } from '../../services/api';
import './BillingTab.css';

interface BillingTabProps {
  billingLoading: boolean;
  billingSummary: BillingSummary | null;
  billingItems: BillingItem[];
  formatCurrency: (amount: number) => string;
  formatDate: (date: string) => string;
}

const BillingTab: React.FC<BillingTabProps> = ({
  billingLoading,
  billingSummary,
  billingItems,
  formatCurrency,
  formatDate,
}) => {
  if (billingLoading) {
    return <div className="billing-loading">Loading billing data...</div>;
  }

  if (!billingSummary) {
    return <div className="empty-state">No billing data available</div>;
  }

  return (
    <div className="billing-section">
      <div className="billing-summary">
        <div className="billing-card">
          <div className="billing-card-label">Total Billable Hours</div>
          <div className="billing-card-value" style={{ color: '#8B5CF6' }}>
            {billingSummary.totalBillableHours.toFixed(2)} hrs
          </div>
        </div>
        <div className="billing-card">
          <div className="billing-card-label">Total Billable Amount</div>
          <div className="billing-card-value" style={{ color: '#8B5CF6' }}>
            {formatCurrency(billingSummary.totalBillableAmount)}
          </div>
        </div>
        <div className="billing-card">
          <div className="billing-card-label">Non-Billable Hours</div>
          <div className="billing-card-value">
            {billingSummary.totalNonBillableHours.toFixed(2)} hrs
          </div>
          <div style={{ fontSize: '0.85rem', color: 'hsl(0, 0%, 65%)', marginTop: '0.5rem' }}>
            {formatCurrency(billingSummary.totalNonBillableAmount)}
          </div>
        </div>
        <div className="billing-card">
          <div className="billing-card-label">Invoiced Amount</div>
          <div className="billing-card-value">
            {formatCurrency(billingSummary.totalInvoicedAmount)}
          </div>
          <div style={{ fontSize: '0.85rem', color: 'hsl(0, 0%, 65%)', marginTop: '0.5rem' }}>
            Unbilled: {formatCurrency(billingSummary.totalUnbilledAmount)}
          </div>
        </div>
      </div>

      {billingItems.length > 0 && (
        <div className="billing-items">
          <h3>Billing Items ({billingItems.length})</h3>
          <div className="billing-table-container">
            <table className="billing-table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Hours</th>
                  <th>Rate</th>
                  <th>Amount</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {billingItems.map((item, idx) => (
                  <tr key={idx}>
                    <td>{formatDate(item.date)}</td>
                    <td>{item.description}</td>
                    <td>{item.billingType}</td>
                    <td>{item.hours.toFixed(2)}</td>
                    <td>{formatCurrency(item.rate)}</td>
                    <td>{formatCurrency(item.amount)}</td>
                    <td>
                      <span className={item.billable ? 'unbilled-badge' : 'invoiced-badge'}>
                        {item.billable ? 'Billable' : 'Non-Billable'}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default BillingTab;

